import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function GenericNextSteps() {
  const contrasts = [{
    reader: 'Reader recognized a real problem',
    step: 'Homepage'
  }, {
    reader: 'Reader wants to apply one idea',
    step: 'Newsletter'
  }, {
    reader: 'Reader may need help',
    step: 'Resource page'
  }, {
    reader: 'Reader is not ready for a sales call',
    step: 'Broad "work with me"'
  }];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative border-t border-gray-200" data-id="element-157">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-158">
        <PathThread data-id="element-159" />
      </div>

      <div className="text-center mb-20" data-id="element-160">
        <Reveal data-id="element-161">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-162">
            A homepage is{' '}
            <span className="italic text-seaglass" data-id="element-163">not a next step</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-164">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-165">
            <p data-id="element-166">Most book paths are too generic.</p>
            <p data-id="element-167">
              A reader gets interested, then lands on the same next step as
              everyone else: homepage, newsletter, resource page, contact form,
              broad "work with me" button, or list of offers.
            </p>
            <p data-id="element-168">That puts too much work on the reader.</p>
            <p className="font-medium text-navy text-xl" data-id="element-169">
              A serious reader should not have to reverse-engineer your business
              to know what to do next.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} data-id="element-170">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-gray-100 mb-24 shadow-[0_12px_30px_-15px_rgba(26,40,56,0.15)]" data-id="element-171">
          <div className="grid gap-6" data-id="element-172">
            {contrasts.map((item, idx) => <div key={idx} className="flex flex-col md:flex-row items-center justify-between gap-4 p-5 bg-paper-dark rounded-2xl border border-gray-100" data-id="element-173">
                <div className="text-navy font-semibold text-center md:text-left flex-1" data-id="element-174">
                  {item.reader}
                </div>

                {/* Broken / thinning connector — the mismatch */}
                <div className="hidden md:flex items-center w-28 flex-shrink-0" data-id="element-175">
                  <div className="w-2 h-2 rounded-full bg-seaglass" data-id="element-176"></div>
                  <div className="flex-1 border-t-2 border-dashed border-gray-300" data-id="element-177"></div>
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-178"></div>
                </div>

                <div className="text-gray-400 font-serif text-lg text-center md:text-right flex-1 line-through decoration-gray-300/70 decoration-1" data-id="element-179">
                  {item.step}
                </div>
              </div>)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.3} data-id="element-180">
        <div id="quick-check-2" className="scroll-mt-32" data-id="element-181">
          <ReaderPathCheck questionId="q1.intent.nextAsk" checkLabel="Quick Check · 2 of 8" confirmationText="Saved." data-id="element-182" />
        </div>
      </Reveal>
    </section>;
}